<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<!-- <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> 
    <mat-icon>keyboard_arrow_down</mat-icon> </button> -->
    <!-- <button mat-menu-item (click)="logout()" style="color:#fff">
        <mat-icon style="color: #fff;">exit_to_app</mat-icon> Log Out </button> -->

<!-- <div class="avatar-container" [matMenuTriggerFor]="profile">
    <div class="avatar">
        <span>AB</span>
    </div>
</div> -->
<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item (click)="navigateProfile()">
        <mat-icon>account_box</mat-icon> Profile </button> -->
</mat-menu>